(function() {
    'use strict';

    angular
        .module('eDocumentsApp')
        .controller('InvoiceLineDeleteController',InvoiceLineDeleteController);

    InvoiceLineDeleteController.$inject = ['$uibModalInstance', 'entity', 'InvoiceLine'];

    function InvoiceLineDeleteController($uibModalInstance, entity, InvoiceLine) {
        var vm = this;

        vm.invoiceLine = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            InvoiceLine.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
